import React, { useState } from "react";
import "../Message/Message.css";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import ChatList from "./ChatList";
import MessageBox from "./MessageBox";
import { useParams } from "react-router";

const Message = ({ chatType }) => {
  const { chatId, tab } = useParams();
  const [selectedChatType, setSelectedChatType] = useState(tab || "GROUP");
  const [selectedChat, setSelectedChat] = useState({});
  const [chatUserList, setChatUserList] = useState(false);
  const [groupDetails, setGroupDetails] = useState({});
  const [memberDetails, setMemberDetails] = useState('')

  const [isReplay, setIsReplay] = useState(false)
  const [selectedReplyData, setSelectReplyData] = useState({})
  // console.log('tab', { tab, chatId, chatType })
  // console.log('selectedChat', selectedChat)
  const tabsName = chatType === 'GROUP' ? "Group Chat" : chatType === 'MEMBER' ? 'Member Chat' : 'chat'
  return (
    <>
      <DashboardHeader title={tabsName || "Message"} />

      <div className={`parent_msg ${chatUserList ? "showList" : ""}`}>
        <ChatList
          selectedChatType={selectedChatType}
          setSelectedChatType={setSelectedChatType}
          setSelectedChat={setSelectedChat}
          chatId={chatId}
          tab={tab}
          groupDetails={groupDetails}
          setMemberDetails={setMemberDetails}
          setGroupDetails={setGroupDetails}
          onClick={() => setChatUserList(false)}

          setIsReplay={setIsReplay}
          setSelectReplyData={setSelectReplyData}

          chatType={chatType}
        />
        <MessageBox
          selectedChat={selectedChat}
          selectedChatType={selectedChatType}
          setSelectedChat={setSelectedChat}
          showChatUsers={() => setChatUserList(!chatUserList)}
          chatId={chatId}
          memberDetails={memberDetails}
          setGroupDetails={setGroupDetails}

          isReplay={isReplay}
          setIsReplay={setIsReplay}
          selectedReplyData={selectedReplyData}
          setSelectReplyData={setSelectReplyData}

          chatType={chatType}
        />
      </div>
    </>
  );
};

export default Message;
